import {
  Flex,
  IconButton,
  Heading,
  SettingsIcon,
  PlusIcon,
} from '@buffer-mono/popcorn'
import { Link } from 'react-router-dom-v5-compat'
import { settingsSavedRepliesRoute } from '~publish/legacy/routes'
import styles from './SavedRepliesPopover.module.css'
import { useCallback } from 'react'

export const SavedReplyHeader = ({
  setOpenForm,
  hasReachedLimit,
  hasSavedReplies,
  setOpenPaywall,
}: {
  setOpenForm: (open: boolean) => void
  hasReachedLimit: boolean
  hasSavedReplies: boolean
  setOpenPaywall: (open: boolean) => void
}): JSX.Element => {
  const handleAddNewSavedReply = useCallback(() => {
    if (hasReachedLimit) {
      setOpenPaywall(true)
    } else {
      setOpenForm(true)
    }
  }, [hasReachedLimit, setOpenPaywall, setOpenForm])

  return (
    <Flex direction="row" justify="between" align="center">
      <Heading size="small" className={styles.header}>
        Saved replies
      </Heading>

      {hasSavedReplies && (
        <Flex direction="row" gap="xs">
          <IconButton
            as={Link}
            to={settingsSavedRepliesRoute.route}
            variant="tertiary"
            size="small"
            label="Settings"
            tooltip="Settings"
          >
            <SettingsIcon />
          </IconButton>

          <IconButton
            variant="secondary"
            size="small"
            label="Add new saved reply"
            onClick={handleAddNewSavedReply}
            tooltip="Add new saved reply"
          >
            <PlusIcon />
          </IconButton>
        </Flex>
      )}
    </Flex>
  )
}
